import { ApplicationFilters } from '../../types/ApplicationFilters';
import { useGetReport } from '../base/useGetReport';

export const useGetApplicationsReport = (
    filters: ApplicationFilters,
    sorting: { direction: 'asc' | 'desc'; field: string }
) => {
    const { downloadReport, downloadingReport } = useGetReport<ApplicationFilters>('applications', filters, sorting);

    return {
        downloadReport,
        downloadingReport
    };
};
